import { VisibleValue } from './types';

export const isVisibleElement = (value: string) => {
	const truthyValues = [VisibleValue.noSet, VisibleValue.visible];
	const isVisible = truthyValues.some(v => v.toLowerCase() === String(value).toLowerCase());
	return isVisible;
};
